import React from 'react';
import moment from 'moment';
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import numeral from 'numeral';

import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import translate from '../../lib/i18n/translate'

const BranchList = ({branches, openBranch, strings}) => {

    const RedIcon = (
            <FontIcon className="material-icons" style={{fontSize: 20, color: LoomisColors.red}}>warning</FontIcon>
        )
    const YellowIcon = (
            <FontIcon className="material-icons" style={{fontSize: 20, color: LoomisColors.yellow}}>error</FontIcon>
        )
    const GreenIcon = (
            <FontIcon className="material-icons" style={{fontSize: 20, color: LoomisColors.green}}>verified_user</FontIcon>
        )
    const OfflineIcon = (
            <FontIcon className="material-icons" style={{fontSize: 20, color: LoomisColors.grey}}>verified_user</FontIcon>
        )

    const {Name, Status, BalanceAmount, LastBalance} = strings;

    return(
        <div className="BranchListContainer">
        <Table style={{tableLayout: 'fixed'}} onCellClick={(rowNumber) => openBranch(rowNumber)}>
            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                <TableRow>
                    <TableHeaderColumn style={{width:'50px'}} className="centerText">{Status}</TableHeaderColumn>
                    <TableHeaderColumn>{Name}</TableHeaderColumn>
                    <TableHeaderColumn style={{width:'80px'}} className="rightText">{LastBalance}</TableHeaderColumn>
                    <TableHeaderColumn  className="rightText">{BalanceAmount}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} showRowHover={true}>
                {branches.map(branch =>
                    <TableRow key={branch.id}>
                        <TableRowColumn style={{width:'50px'}} className="centerText">
                            {branch.worstState === "RED" && RedIcon}
                            {branch.worstState === "YELLOW" && YellowIcon}
                            {branch.worstState === "GREEN" && GreenIcon}
                            {branch.worstState === "OFFLINE" && OfflineIcon}
                        </TableRowColumn>
                        <TableRowColumn>{branch.name}</TableRowColumn>
                        <TableRowColumn style={{width:'80px'}} className="rightText">
                            {branch.lastBalance != null ? moment(branch.lastBalance).format("YYYY-MM-DD"): " "}
                        </TableRowColumn>
                        <TableRowColumn className="rightText">
                            {branch.balance !== null ? (branch.balance.length === 0?'-':null) : '-'}
                            {branch.balance !== null ? branch.balance.map((s,idx)=>(<div style={{float:'right'}} key={idx}>{numeral(s.amount/100).format('0,0.00')} <span style={{color:LoomisColors.darkGrey,fontSize: 10,}}>{s.currency}</span></div>)) : ' '}
                        </TableRowColumn>
                    </TableRow>
                )}
            </TableBody>
        </Table>
        </div>
    )
};

export default translate('BranchList')(BranchList);







// WEBPACK FOOTER //
// ./src/components/branchList/BranchList.js